import React, { useState } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { RootState, AppDispatch } from 'redux/store';
import validator from 'validator';
import Translate from 'lib/Translate';

import Actions from 'redux/Actions';
import Selectors from 'redux/Selectors';

import { RoundInput, Button, BreadCrumb } from '@dm/bigfish';

import NavActions from 'lib/NavActions';

import MainContainer from '../../components/MainContainer';
import CarelineButton from '../../components/CarelineButton';

interface RequestResetPasswordProps {
    loading: boolean;
    requestResetPassword(email: string): void;
}

const RequestResetPassword = ({ requestResetPassword, loading }: RequestResetPasswordProps): JSX.Element => {
    const [email, setEmail] = useState('');
    const [emailError, setEmailError] = useState<boolean | null>(null);
    const [breadCrumb] = useState([
        {
            label: Translate.t('resetPassword.ResetPasswordBcSignUp'),
            onClick: () => { NavActions.navToRegister(); },
        },
        {
            label: Translate.t('resetPassword.ResetPasswordBcOwnerSignUp'),
            onClick: () => { NavActions.navToRegister(); },
        },
        {
            label: Translate.t('resetPassword.ResetPasswordBcForgotPassword'),
            onClick: () => { return false; },
        },
    ]);

    const onBackPressedBreadCrumb = () => {
        NavActions.navBack();
    };

    const onChangeTextEmail = (e: React.ChangeEvent<HTMLInputElement>) => {
        setEmail(e.target.value);
        setEmailError(!validator.isEmail(e.target.value));
    };

    const onSubmitResetPasswordHandler = (e: React.FormEvent) => {
        e.preventDefault();

        if (!emailError) {
            requestResetPassword(email);
        }
    };

    return (
        <>
            <BreadCrumb backLabel={Translate.t('Ui.UiBack')} onBackPressed={onBackPressedBreadCrumb} data={breadCrumb} />
            <MainContainer>
                <Form onSubmit={onSubmitResetPasswordHandler}>
                    <FormTitle>{Translate.t('resetPassword.ResetPasswordTitle')}</FormTitle>
                    <Text>{Translate.t('resetPassword.ResetPasswordDesc')}</Text>
                    <InputGroup label={Translate.t('resetPassword.ResetPasswordEmail')} placeholder={Translate.t('resetPassword.ResetPasswordEmailPlaceholder')} value={email} onChangeText={onChangeTextEmail} inputError={emailError || false} errorText={Translate.t('resetPassword.ResetPasswordErrorEmail')} required />
                    <SubmitButton>
                        <Button loading={loading} label={Translate.t('resetPassword.ResetPasswordLabel')} />
                    </SubmitButton>
                </Form>
                <CarelineContainer>
                    <CarelineButton />
                </CarelineContainer>
            </MainContainer>
        </>
    );
};

const Form = styled.form`
    margin: 0 auto;
    margin-top: 80px;
    padding: 20px;

    max-width: 554px;

    box-sizing: border-box;
    box-shadow: -4px 0px 4px rgba(0, 0, 0, 0.05), 4px 0px 4px rgba(0, 0, 0, 0.05), 0px 4px 4px rgba(0, 0, 0, 0.05), 0px -4px 4px rgba(0, 0, 0, 0.05);
    border-radius: 12px;
`;

const FormTitle = styled.h3`
    font-weight: 700;
    font-size: 18px;
    line-height: 22px;

    margin-bottom: 12px;
`;

const InputGroup = styled(RoundInput)`
    margin-bottom: 28px;
`;

const Text = styled.p`
    font-size: 12px;
    line-height: 14px;
    font-weight: 400;

    color: #696969;

    margin-bottom: 20px;
`;

const SubmitButton = styled.div`
    display: flex;
    width: 100%;
    justify-content: end;
`;

const CarelineContainer = styled.div`
    position: absolute;
    bottom: 23px;
    right: 21px;
`;

const mapStateToProps = (state: RootState) => ({
    loading: Selectors.getAuthRequestResetPassword(state),
    error: Selectors.getAuthRequestResetPasswordError(state),
});

const mapDispatchToProps = (dispatch: AppDispatch) => ({
    requestResetPassword: (email: string) =>
        dispatch(Actions.authRequestResetPasswordAttempt({ email })),
});

export default connect(mapStateToProps, mapDispatchToProps)(RequestResetPassword);
